import axios from 'axios';
import {history} from './history';
import {getAppLang, isDefined, userLogout} from './index';
import {LOGIN, MOBILE_LOGIN_SHORT} from '../constants/appUrls.constants';
import {
    LOGIN_URL,
    REGISTER,
    FORGOT_PASSWORD,
    RESET_PASSWORD,
    REFRESH_TOKEN,
} from '../constants/api.constants';

/*
  401 = oturum gecersiz. Uygulamada bunun icin genel bir davranis yoktu:
  merkezi bir interceptor bulunmuyordu ve 401 yalnizca 3 ekranda, 400/500 ile
  ayni kefeye konup mesaj gosteriliyordu. Sonuc olarak token sunucu tarafinda
  reddedildiginde kullanici bozuk bir ekranda kilitli kaliyor, "Tekrar Dene"
  sonsuza kadar 401 aliyordu.

  store.js'teki checkTokenExpirationMiddleware yalnizca ONGORULU calisiyor:
  JWT'nin exp alanina bakip suresi dolmadan yeniliyor. Token baska bir sebeple
  gecersizlesirse (iptal, sunucuda oturum dusmesi, saat kaymasi) haberi olmuyor.
  Bu interceptor o bosluğu kapatiyor: yanitin kendisine bakiyor.
*/

// Bu uclarda 401 "oturum dustu" demek degil; kimlik dogrulamanin kendisi.
// Ornegin yanlis sifre de 401 doner — kullaniciyi cikisa zorlamamaliyiz.
const AUTH_ENDPOINTS = [
    LOGIN_URL,
    REGISTER,
    FORGOT_PASSWORD,
    RESET_PASSWORD,
    REFRESH_TOKEN,
];

const isAuthRequest = (url) => {
    if (!url) return false;
    return AUTH_ENDPOINTS.some(endpoint => endpoint && url.indexOf(endpoint) !== -1);
};

const isAlreadyOnLoginScreen = () => {
    const path = window.location.pathname;
    return path === LOGIN || path === '/' || path.indexOf(MOBILE_LOGIN_SHORT) === 0;
};

export default function setupAxiosInterceptors(store) {
    axios.interceptors.response.use(
        response => response,
        (error) => {
            const status = error && error.response && error.response.status;
            const url = error && error.config && error.config.url;

            if (status === 401 && !isAuthRequest(url) && !isAlreadyOnLoginScreen()) {
                // Cikis akisi uygulamanin diger yerleriyle ayni (bkz. UserDrawer)
                store.dispatch({ type: 'CLEAR_STATE' });
                userLogout();

                const mobileLogin = localStorage.getItem('mobile_login');
                if (isDefined(mobileLogin)) {
                    history.push(MOBILE_LOGIN_SHORT + mobileLogin);
                } else {
                    history.push(LOGIN);
                }
            }

            // Ag hatasi / zaman asimi: yanit yok. Ekranlarin ~100 yeri korumasiz
            // error.response.data.message okuyor ve burada TypeError ile cokuyordu;
            // api zarfi biciminde bir yanit ekleyip mesaji tek yerden veriyoruz.
            if (error && !error.response && !axios.isCancel(error)) {
                const message = getAppLang() === 'tr'
                    ? 'Sunucuya ulaşılamadı. İnternet bağlantınızı kontrol edip tekrar deneyin.'
                    : 'Could not reach the server. Please check your connection and try again.';
                error.response = {
                    status: 0,
                    data: {status: 0, error: true, errorCode: 'NETWORK_ERROR', message, data: []},
                };
            }

            // Cagiranlar kendi hata gosterimlerini surdurebilsin
            return Promise.reject(error);
        }
    );
}
